export default __webpack_public_path__ + "static/media/world_card_template.25cc5685.svg";